import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTask200To299Service {

  constructor() { }
}
